import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Layout from "../components/layout/Layout";
import ProtectedRoute from "../auth/ProtectedRoute";

import HomePage from "../features/home/HomePage";
import BooksPage from "../features/books/BooksPage";
import ClassesPage from "../features/classes/ClassesPage";
import CartPage from "../features/cart/CartPage";
import CheckoutPage from "../features/checkout/CheckoutPage";
import OrdersPage from "../features/orders/OrdersPage";
import DashboardPage from "../features/dashboard/DashboardPage";
import LoginPage from "../features/auth/LoginPage";
import ServicesPage from "../features/services/ServicesPage";
import AboutPage from "../features/about/AboutPage";
import ContactsPage from "../features/contacts/ContactsPage";

// ScrollToTop component – defined outside AppRoutes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'   // <-- adds smooth animation
    });
  }, [pathname]);

  return null;
}

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />  {/* This will run on every route change */}
      <Routes>
        {/* Wrap only once with Layout */}
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/books" element={<BooksPage />} />
          <Route path="/classes" element={<ClassesPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route
            path="/checkout"
            element={<CheckoutPage />}
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;